export const main = {
    login:'Log in',
    register:'Register',
    sy: 'Home',
    cpzx: "Products",
    jjfa: "Solution",
    hyyy: "Industry",
    fwyzc: "Service",
    gywm: "About",
    xlwjxj: "INS-CHVS series macro camera",
    ljkzq: "INS-LC-0532-001 logic controller",
    sjkzq: "INSBOX-VSC-CM vision controller",
    sdxxrj: "INSAI deep learning software",
    sjjcpt: "INS-3D Vision Inspection Platform",
    sjcl: "Visual Measurement",
    sjjc: "Visual Inspection",
    sjyd: "Visual Guidance",
    jcsb: "AOI Testing Equipment",
    xnyld: "New energy lithium battery",
    wl:'Logistics',
    qcyzdh:'Automotive and Automation',
    cpsc:'Manual',
    gsjs:'Company',
    lxwm:'Contact',
}